/* Mintier Skin Quiz pop-up + quiz deep-link helper. No discount, no timer. Shows once per browsing session to everyone. */
(function(){
  'use strict';
  try{
  var KEY='mintier_quizpopup';
  var QUIZ='/pages/skin-quiz';
  var MAP={forehead:'Forehead',eyes:'Around my eyes',cheeks:'Cheeks / mid face',jawline:'Jawline / lower face',sleep:'Better sleep'};
  var OPTS=[['Forehead',QUIZ+'?focus=forehead'],['Around my eyes',QUIZ+'?focus=eyes'],['Cheeks / mid face',QUIZ+'?focus=cheeks'],['Jawline / lower face',QUIZ+'?focus=jawline'],['Better sleep',QUIZ+'?focus=sleep']];
  var SKIP=['wholesale','free-sample','rose-beauty-mouth-tape','ws-account-login','sleep-mouth-tape','waitlist','eye-dream-collagen-tape'];
  var IMG='/cdn/shop/files/21.png';

  /* once per browsing session (sessionStorage); the old permanent localStorage flag is cleared so past visitors and customers see it again */
  try{localStorage.removeItem(KEY)}catch(e){}
  var ls={get:function(){try{return sessionStorage.getItem(KEY)}catch(e){return null}},set:function(v){try{sessionStorage.setItem(KEY,v)}catch(e){}}};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var path=location.pathname.replace(/\/+$/,'')||'/';
  if(root!=='/'&&path.indexOf(root.replace(/\/$/,''))===0)path=path.slice(root.length-1)||'/';
  var params=new URLSearchParams(location.search);
  var force=params.get('quizpopup')==='1';

  /* ---- quiz page: remember the visit (this session only) and pre-pick the first answer ---- */
  if(path===QUIZ){
    ls.set('quiz');
    var title=MAP[(params.get('focus')||'').toLowerCase()];
    if(title){
      var t0=Date.now(),done=false;
      var tick=function(){
        if(done)return;
        try{
          var el=document.querySelector('li.oct-quiz-picture-choice-options__option[title="'+title+'"]')||document.querySelector('[aria-label="'+title+'"]');
          if(el){done=true;el.click();return}
        }catch(e){done=true;return}
        if(Date.now()-t0<10000)setTimeout(tick,200);
      };
      tick();
    }
    if(!force)return;
  }

  /* ---- pop-up eligibility ---- */
  if(!force){
    if(ls.get())return;
    if(window.Shopify&&Shopify.designMode)return;
    if(/^\/(cart|checkout|checkouts|account|challenge|password)(\/|$)/.test(path))return;
    var seg=path.split('/').pop();
    if(SKIP.indexOf(seg)>-1)return;
  }

  var cssHref=(document.currentScript&&document.currentScript.getAttribute('data-css'))||null;
  var cssReady=false,shown=false;
  function loadCss(cb){
    if(!cssHref||cssReady){cssReady=true;cb();return}
    var l=document.createElement('link');l.rel='stylesheet';l.href=cssHref;
    l.onload=l.onerror=function(){cssReady=true;cb()};
    document.head.appendChild(l);
  }
  function srcset(){return [600,800,1000,1400].map(function(w){return IMG+'?width='+w+' '+w+'w'}).join(', ')}
  /* warm the photo early so it is there when the pop-up opens */
  function preload(){var i=new Image();i.sizes='(min-width: 900px) 50vw, 100vw';i.srcset=srcset();i.src=IMG+'?width=1000'}

  var lastFocus=null,dlg=null;
  function esc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;')}
  function build(){
    dlg=document.createElement('div');
    dlg.id='mtq';dlg.setAttribute('role','dialog');dlg.setAttribute('aria-modal','true');dlg.setAttribute('aria-labelledby','mtq-h');dlg.tabIndex=-1;
    dlg.innerHTML=
      '<button type="button" class="mtq-x" aria-label="Close"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg></button>'+
      '<div class="mtq-ph"><img src="'+IMG+'?width=1000" srcset="'+srcset()+'" sizes="(min-width: 900px) 50vw, 100vw" width="1000" height="1000" alt="Woman relaxing in bed wearing Mintier forehead tape" decoding="async" fetchpriority="high"></div>'+
      '<div class="mtq-in">'+
        '<p class="mtq-eyebrow">30-second skin quiz</p>'+
        '<h2 class="mtq-h" id="mtq-h">Find your overnight ritual</h2>'+
        '<p class="mtq-sub">Tell us what you\u2019d like to focus on and we\u2019ll match you with the right tapes.</p>'+
        '<p class="mtq-q" id="mtq-q">What area do you want to focus on most?</p>'+
        '<ul class="mtq-pills" aria-labelledby="mtq-q">'+OPTS.map(function(o){return '<li><a href="'+o[1]+'">'+esc(o[0])+'</a></li>'}).join('')+'</ul>'+
        '<button type="button" class="mtq-later">Not right now</button>'+
      '</div>';
    dlg.querySelector('.mtq-x').addEventListener('click',close);
    dlg.querySelector('.mtq-later').addEventListener('click',close);
    [].forEach.call(dlg.querySelectorAll('.mtq-pills a'),function(a){a.addEventListener('click',function(){ls.set('clicked')})});
    dlg.addEventListener('keydown',onKey);
    document.body.appendChild(dlg);
  }
  function focusables(){return [].slice.call(dlg.querySelectorAll('a[href],button')).filter(function(e){return e.offsetParent!==null||getComputedStyle(e).position==='fixed'})}
  function onKey(e){
    if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();close();return}
    if(e.key==='Tab'){
      var f=focusables();if(!f.length)return;
      var first=f[0],last=f[f.length-1],a=document.activeElement;
      if(e.shiftKey&&(a===first||a===dlg||!dlg.contains(a))){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&(a===last||!dlg.contains(a))){e.preventDefault();first.focus()}
    }
  }
  function trapIn(e){if(dlg&&!dlg.hidden&&!dlg.contains(e.target)){e.stopPropagation();var f=focusables();(f[1]||f[0]||dlg).focus()}}
  function show(){
    if(shown)return;shown=true;
    cleanup();
    if(!force)ls.set('seen');
    loadCss(function(){
      build();
      lastFocus=document.activeElement;
      document.documentElement.classList.add('mtq-open');
      document.addEventListener('focusin',trapIn,true);
      requestAnimationFrame(function(){dlg.classList.add('is-in')});
      dlg.focus({preventScroll:true});
    });
  }
  function close(){
    ls.set(ls.get()==='clicked'?'clicked':'seen');
    if(!dlg)return;
    document.removeEventListener('focusin',trapIn,true);
    document.documentElement.classList.remove('mtq-open');
    dlg.parentNode&&dlg.parentNode.removeChild(dlg);dlg=null;
    if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true})}catch(e){}
  }
  var timer=null;
  function onScroll(){
    var h=document.documentElement.scrollHeight-window.innerHeight;
    if(h>0&&window.scrollY/h>=0.15)show();
  }
  function cleanup(){clearTimeout(timer);window.removeEventListener('scroll',onScroll)}
  function start(){
    preload();
    if(force){show();return}
    timer=setTimeout(show,4000);
    window.addEventListener('scroll',onScroll,{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  }catch(err){/* fail silently */}
})();
